"use client"

import { useVaultStatus } from "@/hooks/useVaultStatus"

export function VaultStatusBanner() {
  const { data } = useVaultStatus()
  if (data !== false) return null
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="bg-red-600 text-white px-4 py-3 text-sm"
    >
      Some platform actions are temporarily unavailable. Please try again in a few minutes.
    </div>
  )
}
